import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5efeb7a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-duration" }
const _hoisted_2 = { class: "days-row" }
const _hoisted_3 = { class: "days" }
const _hoisted_4 = ["onClick", "data-duration"]
const _hoisted_5 = { class: "days-select-wrapper" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = {
  key: 0,
  class: "form-control"
}
const _hoisted_8 = {
  key: 1,
  class: "form-control"
}
const _hoisted_9 = ["value", "data-duration"]

import { ref, Ref, defineModel } from "vue";
import SelectIcon from "@/components/icons/SelectIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchDuration',
  props: {
    "modelValue": {
  type: Number,
},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const selectedDay = _useModel(__props, "modelValue");

const days: Ref<number[]> = ref([7, 15, 30]);
const allDays: Ref<number[]> = ref([90, 180, 360]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day) => {
          return (_openBlock(), _createElementBlock("button", {
            key: day,
            class: _normalizeClass(["day-button", { active: selectedDay.value === day }]),
            onClick: ($event: any) => (selectedDay.value = day),
            "data-duration": day
          }, _toDisplayString(day) + " days ", 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (!selectedDay.value || days.value.includes(selectedDay.value))
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " I need more days "))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(selectedDay.value === 360 ? "Unlimited" : `${selectedDay.value} days`), 1)),
          _createVNode(SelectIcon, { class: "input-suffix" })
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "days-select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDay).value = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allDays.value, (day) => {
            return (_openBlock(), _createElementBlock("option", {
              key: day,
              value: day,
              "data-duration": day
            }, _toDisplayString(day === 360 ? "Unlimited" : `${day} days`), 9, _hoisted_9))
          }), 128))
        ], 512), [
          [_vModelSelect, selectedDay.value]
        ])
      ])
    ])
  ]))
}
}

})